import React from "react";

const SVG = ({
  width = "100%",
  className = "",
  viewBox = "0 0 24 24",
  color = "#0062FF",
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M3 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0M15 6a3 3 0 1 0 6 0 3 3 0 0 0-6 0M15 18a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
        stroke={color}
        strokeWidth="1.5"
        fill={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.7 10.7 6.6-3.4M8.7 13.3l6.6 3.4"
      />
    </g>
  </svg>
);

export default SVG;
